import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/',
    name: 'Layout',
    component: () => import('@/views/Layout.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: '首页', icon: 'HomeFilled' }
      },
      {
        path: 'venue',
        name: 'Venue',
        component: () => import('@/views/venue/VenueList.vue'),
        meta: { title: '场馆管理', icon: 'OfficeBuilding' }
      },
      {
        path: 'court',
        name: 'Court',
        component: () => import('@/views/court/CourtList.vue'),
        meta: { title: '场地管理', icon: 'Basketball' }
      },
      {
        path: 'booking',
        name: 'Booking',
        component: () => import('@/views/booking/BookingManage.vue'),
        meta: { title: '预约管理', icon: 'Calendar' }
      },
      {
        path: 'booking-list',
        name: 'BookingList',
        component: () => import('@/views/booking/BookingListView.vue'),
        meta: { title: '预约列表', icon: 'List' }
      },
      {
        path: 'user',
        name: 'User',
        component: () => import('@/views/user/UserManage.vue'),
        meta: { title: '用户管理', icon: 'UserFilled' }
      },
      {
        path: 'user-recharge',
        name: 'UserRecharge',
        component: () => import('@/views/user/UserRechargeList.vue'),
        meta: { title: '充值记录', icon: 'Wallet' }
      },
      {
        path: 'recharge-activity',
        name: 'RechargeActivity',
        component: () => import('@/views/user/RechargeActivity.vue'),
        meta: { title: '充值活动', icon: 'Money' }
      },
      {
        path: 'notice',
        name: 'Notice',
        component: () => import('@/views/notice/NoticeList.vue'),
        meta: { title: '公告管理', icon: 'BellFilled' }
      },
      {
        path: 'system',
        name: 'System',
        component: () => import('@/views/system/SystemConfig.vue'),
        meta: { title: '系统配置', icon: 'Tools' }
      },
      {
        path: 'banner',
        name: 'Banner',
        component: () => import('@/views/system/BannerManage.vue'),
        meta: { title: '轮播图管理', icon: 'Picture' }
      },
      {
        path: 'admin',
        name: 'Admin',
        component: () => import('@/views/system/AdminManage.vue'),
        meta: { title: '管理员管理', icon: 'User' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.path !== '/login' && !token) {
    next('/login')
  } else {
    next()
  }
})

export default router
